import { Box } from '@mui/material'
import { CarrierVisitStatus } from '@operations/app/api'
import { CarrierVisitViewStatus } from '@operations/utils/helper'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, ColorSchema, useMinimalsTheme } from '@tom-ui/ui'
import { useMemo } from 'react'

interface Props {
  status: CarrierVisitViewStatus
}
export const CarrierVisitStatusChip = ({ status }: Props) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const currentStatus: { label: string; color: ColorSchema } = useMemo(() => {
    switch (status) {
      case CarrierVisitStatus.Arrived:
        return { label: t('arrived', 'Arrived'), color: 'primary' }
      case CarrierVisitStatus.InOperation:
        return { label: t('inOperation', 'In operation'), color: 'busy' }
      case CarrierVisitStatus.Completed:
        return { label: t('completed', 'Completed'), color: 'primary' }
      case CarrierVisitStatus.Departed:
        return { label: t('departed', 'Departed'), color: 'primary' }
      case CarrierVisitStatus.Closed:
        return { label: t('closed', 'Closed'), color: 'secondary' }
      case CarrierVisitViewStatus.Berthed:
        return { label: t('berthed', 'Berthed'), color: 'primary' }
      default:
      case CarrierVisitStatus.Expected:
        return { label: t('expected', 'Expected'), color: 'info' }
    }
  }, [status, t])

  return (
    <Box data-cy='carrier-visit-status-chip'>
      <ColoredLabel
        label={currentStatus.label}
        color={currentStatus.color}
        sx={{
          width: 'fit-content',
          // todo: switch color hack for visit details page that can be removed once we update to the new design
          backgroundColor:
            currentStatus.color === 'secondary'
              ? '#F9FAFB'
              : theme.palette[currentStatus.color].lighter,
        }}
      />
    </Box>
  )
}
